export const API_ADMIN_GET_ALL_MOTIVATIONSLIBRARY = "API_ADMIN_GET_ALL_MOTIVATIONSLIBRARY";
export const API_ADMIN_GET_ALL_MOTIVATIONSLIBRARY_SUCCESS = "API_ADMIN_GET_ALL_MOTIVATIONSLIBRARY_SUCCESS";
export const API_ADMIN_GET_ALL_MOTIVATIONSLIBRARY_FAIL = "API_ADMIN_GET_ALL_MOTIVATIONSLIBRARY_FAIL";

export const API_ADMIN_GET_MOTIVATIONLIBRARY = "API_ADMIN_GET_MOTIVATIONLIBRARY";
export const API_ADMIN_GET_MOTIVATIONLIBRARY_SUCCESS = "API_ADMIN_GET_MOTIVATIONLIBRARY_SUCCESS";
export const API_ADMIN_GET_MOTIVATIONLIBRARY_FAIL = "API_ADMIN_GET_MOTIVATIONLIBRARY_FAIL";

export const API_ADMIN_POST_MOTIVATIONLIBRARY = "API_ADMIN_POST_MOTIVATIONLIBRARY";
export const API_ADMIN_POST_MOTIVATIONLIBRARY_SUCCESS = "API_ADMIN_POST_MOTIVATIONLIBRARY_SUCCESS";
export const API_ADMIN_POST_MOTIVATIONLIBRARY_FAIL = "API_ADMIN_POST_MOTIVATIONLIBRARY_FAIL";

export const API_ADMIN_PATCH_MOTIVATIONLIBRARY = "API_ADMIN_PATCH_MOTIVATIONLIBRARY";
export const API_ADMIN_PATCH_MOTIVATIONLIBRARY_SUCCESS = "API_ADMIN_PATCH_MOTIVATIONLIBRARY_SUCCESS";
export const API_ADMIN_PATCH_MOTIVATIONLIBRARY_FAIL = "API_ADMIN_PATCH_MOTIVATIONLIBRARY_FAIL";

export const API_ADMIN_DELETE_MOTIVATIONLIBRARY = "API_ADMIN_DELETE_MOTIVATIONLIBRARY";
export const API_ADMIN_DELETE_MOTIVATIONLIBRARY_SUCCESS = "API_ADMIN_DELETE_MOTIVATIONLIBRARY_SUCCESS";
export const API_ADMIN_DELETE_MOTIVATIONLIBRARY_FAIL = "API_ADMIN_DELETE_MOTIVATIONLIBRARY_FAIL";

export const ADMIN_RESET_FOCUS_MOTIVATIONLIBRARY = "ADMIN_RESET_FOCUS_MOTIVATIONLIBRARY";
export const ADMIN_INIT_NEW_MOTIVATIONLIBRARY = "ADMIN_INIT_NEW_MOTIVATIONLIBRARY";
